import React, { useMemo } from "react";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
} from "../../usecases/object";
import withRouter from "../../withRouter";
import BaseListPage from "../../base/BaseListPage";

import PortalSearch from "../../components/PortalSearch";
import ApplicationStatusListPresenter from "./ApplicationStatusListPresenter";
import ApplicationCard from "../../components/ApplicationCard";

class ApplicationStatusList extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new ApplicationStatusListPresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase()
    );
    this.state = {
      isChecked: false,
      isModalOpen: false,
      objects: [],
      selected: [],
      count: 0,
      progress: false,
      schema: {},
      searchQuery: "",
    };
  }

  getCollectionName() {
    return "online_applicants";
  }

  componentDidMount() {
    this.presenter.findObjects();
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setTotal(count) {
    this.setState({ count });
  }

  displayModal(productId) {
    this.setState({ isModalOpen: true, productId });
  }

  closeModal() {
    this.setState({ isModalOpen: false, productId: null });
  }

  onSelect(object) {
    this.setState(
      (prevState) => {
        const isSelected = prevState.selected.some(
          (item) => item.id === object.id
        );

        const updatedSelected = isSelected
          ? prevState.selected.filter((item) => item.id !== object.id)
          : [...prevState.selected, object];

        return {
          selected: updatedSelected,
          isChecked: updatedSelected.length > 0,
        };
      },
      () => {}
    );
  }

  getSelectedItems() {
    return this.state.selected;
  }
  onclickApplyNow() {
    this.presenter.onClickApplyNow();
  }
  onclickDetails() {
    this.presenter.onclickDetails();
  }

  handleSearch = (event) => {
    this.setState({ searchQuery: event.target.value });
  };

  render() {
    const { objects, isChecked, searchQuery } = this.state;
    // const filteredObjects = objects.filter((object) =>
    //   object.positionApplied.toLowerCase().includes(searchQuery.toLowerCase())
    // );

    const filteredObjects = objects.filter((object) =>
      object.referenceNumber.includes(searchQuery)
    );

    return (
      <>
        <div>
          <div
            className="d-flex flex-column pt-5 px-5 gap-3 container-fluid"
            style={{ marginTop: `5rem` }}
          >
            <div className="container-fluid">
              <h1 className="fw-bold fs-1">
                Application <span style={{ color: `#D18237` }}>Status</span>
              </h1>
            </div>

            <div className="w-100">
              <PortalSearch
                schemas={this.getSchemas()}
                onChange={this.handleSearch.bind(this)}
                className="col-lg-4 col-md-6"
                placeholder="Search reference number"
              ></PortalSearch>
            </div>
          </div>
        </div>

        <div className="container-fluid w-100 position-relative">
          <div className="row row-cols-sm-1 row-cols-md-2 row-cols-lg-3 px-5 pb-4">
            {filteredObjects.length > 0 ? (
              filteredObjects.map((object, index) => (
                <div className="col" key={index}>
                  <ApplicationCard index={index} object={object} />
                </div>
              ))
            ) : (
              <div className="col text-center text-muted mt-3 w-100 fw-bold fs-5 p-5">
                No results found
              </div>
            )}
          </div>

          <button
            className={`position-fixed btn text-white rounded-5 ps-5 pe-5 fw-bold fs-6 py-3 ms-auto ${
              isChecked ? "d-block" : "d-none"
            }`}
            style={{
              backgroundColor: "#D18237",
              bottom: `5%`,
              left: `50%`,
              transform: `translate(-50%,-50%)`,
            }}
            onClick={this.onclickApplyNow.bind(this)}
          >
            Apply Now
          </button>
        </div>
      </>
    );
  }
}

export default withRouter(ApplicationStatusList);
